import {useEffect} from "react";
import {HelmetProvider} from "react-helmet-async";
import ErrorPage from "../components/error/404";
import Seo from "../components/Seo";

const Home = () => {


    useEffect(() => {

    }, [])

    return (
        <HelmetProvider>
            <Seo
                title="404 | UCC"
                description="The page you are looking for could not be found."
                noIndex
            />
            <ErrorPage/>
        </HelmetProvider>
    )


}


export default Home;
